/**
 * Spec 20261015-160924 T12: the ERP lives in portal-senneliquor, at `VITE_APP_SCHEDULE_URL` (the same address the
 * Agendamento entry opens). The full address of an ERP path, or `null` when the base is not configured.
 */
export function erpUrl(base: string | undefined, path: string): string | null {
  const root = (base ?? "").trim().replace(/\/+$/, "");
  if (!root) return null;
  return `${root}${path.startsWith("/") ? path : `/${path}`}`;
}

/** The ERP pages that left this portal, by where they live now. */
export const ERP_PATHS = {
  home: "/erp",
  carlaoConfiguracao: "/erp/carlao/configuracao",
  carlaoAnalytics: "/erp/carlao/analytics",
  observabilidade: "/erp/sistema/observabilidade",
} as const;
